import { Command } from "commander";
import chalk from "chalk";
import { runAudit } from "../audit/auditEngine.js";
import type { AuditFinding } from "../models/AuditResult.js";

const SEVERITY_ICON = {
  error: chalk.red("✖"),
  warning: chalk.yellow("⚠"),
  info: chalk.cyan("ℹ"),
};

function printFindings(label: string, findings: AuditFinding[], color: chalk.Chalk): void {
  if (findings.length === 0) return;
  console.log(color.bold(label));
  for (const f of findings) {
    const icon = SEVERITY_ICON[f.severity] ?? chalk.dim("·");
    console.log(`  ${icon} [${f.category}] ${f.message}`);
    if (f.detail) console.log(`    ${chalk.dim(f.detail)}`);
    if (f.suggestion) console.log(`    ${chalk.dim("→")} ${chalk.dim(f.suggestion)}`);
  }
  console.log();
}

export const auditCommand = new Command("audit")
  .description("Detect configuration drift in your React Native project")
  .option("--json", "Output in JSON format")
  .action(async (options: { json?: boolean }) => {
    const cwd = process.cwd();
    try {
      const result = await runAudit(cwd);

      if (options.json) {
        console.log(JSON.stringify(result, null, 2));
        process.exit(result.passed ? 0 : 1);
        return;
      }

      console.log();
      console.log(chalk.bold.underline("Project Audit — Drift Detection"));
      console.log();

      const statusColor = result.passed ? chalk.green : chalk.red;
      const statusLabel = result.passed ? "PASSED" : "DRIFT DETECTED";
      console.log(`  Status: ${statusColor.bold(statusLabel)}`);
      console.log(
        `  Findings: ${chalk.red(result.errors.length + " errors")}  ${chalk.yellow(result.warnings.length + " warnings")}  ${chalk.cyan(result.infos.length + " infos")}`
      );
      console.log();

      printFindings("Errors", result.errors, chalk.red);
      printFindings("Warnings", result.warnings, chalk.yellow);
      printFindings("Info", result.infos, chalk.cyan);

      process.exit(result.passed ? 0 : 1);
    } catch (err: any) {
      if (options.json) {
        console.log(JSON.stringify({ success: false, error: err?.message }, null, 2));
      } else {
        console.log(chalk.red(`✖ ${err?.message || "Unknown error"}`));
      }
      process.exit(1);
    }
  });
